import ContactCard from './../components/ContactCard';
import Heading from './../components/Heading';
import SmallHeading from './../components/SmallHeading';
import DetailsHeading from './../components/DetailsHeading';

function ContactSection() {
  return (
    <section className='py-10'>
    <SmallHeading name="Contact Us" tstyle="text-center my-1 mt-10"/>
    <Heading name="Get in Touch Now" tstyle="text-center my-1"/>
    <div className='mt-4 px-10' >
      <DetailsHeading 
      name="Looking for personalized assistance? Contact us today for dedicated support and guidance." 
      tstyle="my-1"
      />
    </div>
    <div>
      <ContactCard/>
    </div>

    </section>
  );
}

export default ContactSection;

